<!-- TODO: Multilang -->
<template>
  <v-container fill-height fluid class="bgimg-fill" :style="bgImg">
    <v-layout fluid fill-height align-center justify-center
      >
      <v-card
        width="475px"
        height="475px"
        class="elevation-20 rounded-10"        
        @keydown.enter.prevent="checkLogin"
      >
        <v-card-title>
          <div class="qmkey-login-logo-container layout column align-center ">
            <v-img
              center
              :src="sede_logo_path"
              alt="Sede Logo"
              max-width="340px"
              max-height="120px"
              contain>
            </v-img>
          </div>
        </v-card-title>
        <v-card-subtitle class="login-card-subtitle pb-5">
          {{ $t('identify') }}
          <v-divider class="login-card-subtitle-divider"></v-divider>
        </v-card-subtitle>
        

        <v-card-text>
          <v-form
            class="qmkey-login-form"
            autocomplete="off"
          >
            <v-text-field
              id="username"
              name="username"
              :label="$t('email')"
              type="text"
              v-model="creds.username"
              required
              placeholder=" "
              persistent-placeholder
              outlined
              dense
              class="qmkey-login-input"
            />
            <v-text-field
              id="password"
              name="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              v-model="creds.password"
              :label="$t('password')"
              required
              :placeholder="$t('password')"
              @click:append="show1 = !show1"
              automcomplete="new-password"
              outlined
              dense
              class="qmkey-login-input"
            />
          </v-form>
          <div class="qmkey-login-router-link text-right">
            <!-- TODO: reset password or something else -->
            <!-- <router-link
              class="pointer"
              to="/forgotten-password"
              v-if="!sso.enabled"
            >
              ¿Has olvidado la contraseña?
            </router-link> -->
          </div>
          <div class="qmkey-login-router-link text-right">
            <router-link
              class="pointer"
              to="/ssologin"
              v-if="sso.enabled && sso.loginURL"
            >
              Autenticar mediante {{ sso.name }}
            </router-link>
          </div>
          <div>
            <v-alert
              dense
              outlined
              type="error"
              v-model="alert"
              dismissible
            >
              {{ message }}
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            rounded
            large
            min-width="150px"
            class="qmkeky-login-button"
            @click.prevent="checkLogin"
          >
            {{ $t('login') }}
          </v-btn>
        </v-card-actions>
        <!-- <v-container>
        <v-row >
            <v-col class="text-right" cols="12">
              <a href="//www.kmkey.com">
                <v-chip
                  color="white"
                  label
                  :ripple="false"
                  class="login-notice overflow-visible"
                  x-small
                >Powered by
                <v-img
                src="../assets/logo.png"
                alt="Sede Logo"
                max-width="50px"
                max-height="50px"
                class="ml-auto"
                small
                >
                </v-img>
                </v-chip>
              </a>
              <v-spacer></v-spacer>
            </v-col>
          </v-row>
        </v-container> -->
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
 import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
 import customThemes from '@/plugins/themes.js'
 import QCentro from '@/api/QCentro.js';
 import QToken from '@/api/QToken.js';
 import APILogin from '@/api/Login.js';
 import QSite from '@/api/Site.js';
 import { get_settings } from '@/settings.js';


 export default {
   name: 'app_login',
   cache: false,
   data: function() {
     return {
       message: '',
       creds: { username: null, password: null },
       loading: false,
       sede_logo_path: '/assets/logo_earcon.gif',
       show1: false,
       alert: false,
       default_site: null,
       sso: this.$sso,
       bgImg: {
         backgroundImage: "url('"+customThemes.loginBackground+"')",
       },
       enter_centro: null,
       enter_site: null,
     }
   },

   // mounted() {
   //   // Keypresses on overlay:
   //   document.addEventListener('keydown', this.onKeydown)
   // },

   computed: {
     ...mapGetters(['sitePath', 'user', 'centro_id']),
     ...mapState(['currentTheme', 'UserSession']),
   },

   methods: {
     ...mapActions({
       set_user: 'set_user',
       purge_session: 'UserSession/purge_session',
       set_token: 'UserSession/set_token',
       set_session_cookie: 'UserSession/set_session_cookie', // true|flase
       set_user: 'UserSession/set_user',
       set_root_site: 'UserSession/set_root_site',
       set_site: 'UserSession/set_site',
       set_centro: 'UserSession/set_centro',
       query_user_data: 'UserSession/query_user_data',
       query_site_data: 'UserSession/query_site_data',
       update_site_data: 'UserSession/update_site_data',
     }),
     ...mapActions(['REFRESH_STATE', 'CHANGE_THEME']),
     ...mapMutations(['SET_CURRENT_SITE']),

     async getUserInfoAndRedirect() {
       await this.query_user_data();
       this.REFRESH_STATE(this);
       console.log("getUserInfoAndRedirect", this.user)
       if (this.user) {
         this.$vuetify.lang.current = this.user.lang ? this.user.lang  : 'es';
       }
       if (this.$route.query.redirect) {
         this.$router.push(this.$route.query.redirect);
       } else {
         this.$router.push('preferences');
       }
     },

     async checkLogin() {
       // Login entry point
       const settings = get_settings();

       this.loading = true;
       this.message = '';
       await this.purge_session();

       if (settings.login_type === 'token') {
         await this.do_token_login();
       } else {
         await this.do_session_login();
       }

       this.loading = false;
     },

     async do_session_login() {
       try {
         const user = await APILogin.login(this.creds.username, this.creds.password);
         this.set_session_cookie(true);
         this.set_root_site(user.site);
         this.set_centro(this.enter_centro || user.default_centro);
         await this.query_site_data(this.enter_site || user.site);
         await this.getUserInfoAndRedirect(user.site);

       } catch (err) {
         console.warn(err);
         const msg = ("El correo electrónico y/o la contraseña son incorrectos."
                    + " Por favor, inténtalo de nuevo o restablece tu contraseña");
         this.render_form_errors(msg);
         this.alert = true;
       }
     },

     async do_token_login() {
       try {
         const data_token = await QToken.login(this.creds);
         this.set_token(data_token['key']);
         const data = await QToken.get(data_token['key']);
         this.set_root_site(data['root_site']);
         this.set_centro(this.enter_centro || data['default_centro']);
         await this.query_site_data(this.enter_site || data['root_site']);
         await this.getUserInfoAndRedirect(data['root_site']);

       } catch (err) {
         console.warn(err);
         const msg = ("El correo electrónico y/o la contraseña son incorrectos."
                    + " Por favor, inténtalo de nuevo o restablece tu contraseña");
         this.render_form_errors(msg);
         this.alert = true;
       }
     }
   },

   watch: {
     currentTheme: function(theme) {
       this.bgImg.backgroundImage = "url('"+customThemes[theme].loginBackground+"')";
     },

     '$route.params.sede': {
       async handler(sede) {
         if (!sede)
           return;
         // Login in specific centro
         
         try {
           const data = await QCentro.url_name_to_path(sede);
           if (data.background_image){
             this.bgImg.backgroundImage="url('"+data.background_image+"')";
           } else {
             this.CHANGE_THEME(data.qmkey_product);
           }
           this.sede_logo_path = data.logo;
           this.enter_centro = data.id;
           this.enter_site = data.site;

         } catch (err) {
           this.$router.push('/404');
         }  
       },
       deep: true,
       immediate: true
     },

     '$route.params.corp': {
       async handler(corp) {
         if (!corp)
           return;
         // Login in specific empresa

         try {
           const data = await QSite.url_name_to_path(corp);
           if (data.background_image){
             this.bgImg.backgroundImage="url('"+data.background_image+"')";
           } else {
             this.CHANGE_THEME(data.qmkey_product);
           }
           this.sede_logo_path = data.logo;
           // Note: wait to user data to set preferred centro
           //  this.enter_centro = data.id; 
           this.enter_site = data.site;

         } catch (err) {
           console.log(err)
           this.$router.push('/404');
         }  
       },
       deep: true,
       immediate: true
     },
   },
 }
</script>


<style lang="scss">
 @import "@/sass/login.scss";
</style>
